module.exports = __webpack_public_path__ + "static/media/logo-word.1bda4f53.svg";